import Vue from 'vue'
import VueRouter from 'vue-router'
import { Router } from '@/app/router'
import routes from '@/routes'
import InspectMiddleware from '@middleware/Inspect'
import MfaEnforcementMiddleware from '@middleware/MfaEnforcement'
import PermissionsMiddleware from '@middleware/Permissions'
import CancelRequestsMiddleware from '@middleware/CancelRequests'

Vue.use(VueRouter)

const dashboardScrollPositions = new Map()
let trackedScroller = null

const getDashboardScroller = () => (typeof document !== 'undefined' ? document.getElementById('dashboard-main') : null)

const trackDashboardScroller = el => {
	if (trackedScroller === el) return
	trackedScroller = el
	el.addEventListener('scroll', () => {
		const key = window.history.state && window.history.state.key
		if (!key) return
		dashboardScrollPositions.set(key, el.scrollTop)
		if (dashboardScrollPositions.size > 50) {
			dashboardScrollPositions.delete(dashboardScrollPositions.keys().next().value)
		}
	}, { passive: true })
}

export function createVueRouter () {
	const router = new Router(VueRouter, routes, {
		mode: 'history',
		scrollBehavior: (to, from, savedPosition) => {
			const scroller = getDashboardScroller()
			if (!scroller) return savedPosition || { x: 0, y: 0 }
			trackDashboardScroller(scroller)
			const key = window.history.state && window.history.state.key
			scroller.scrollTo(0, (savedPosition && dashboardScrollPositions.get(key)) || 0)
			return false
		},
		middlewares: [InspectMiddleware, MfaEnforcementMiddleware, PermissionsMiddleware, CancelRequestsMiddleware]
	})
	router.VueRouter.afterEach((to, from) => {
		if (typeof window !== 'undefined') {
			const pickRouteFields = ({ path, name, params, query, fullPath }) => ({ path, name, params, query, fullPath })
			window.navigationHistory = {
				to: pickRouteFields(to),
				from: pickRouteFields(from),
				timestamp: Date.now()
			}
		}
	})

	return router
}
